import React from "react";
import "./globalservicebanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const GlobalServiceBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          {/* High-priority, eager-loaded image */}
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/4.%20Global%20Services.webp"
            alt="Global Services Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />

          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-md-5 mt-3">
              <p className="fs4 text-uppercase busy">Blueberry Travel</p>
              <h1 className="banner-headings w-75">
                Networks That Inspire Reach
              </h1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  How can your business achieve excellent global connectivity?
                  Thanks to our partnerships and strong network, we connect you
                  to opportunities, destinations, and experiences.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default GlobalServiceBanner;
